import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import ReactHtmlParser from "components/Common/ReactHtmlParser";
import "./proceed-checkout.scss";
import { getLocalStorageValue } from 'config/helper';
import useShippingLabel from 'hooks/useShippingLabel';
import { useConfigHeader } from 'hooks/useConfig';

const ProceedCheckout = ({ productCartList, cartType }) => {
  const { productCartDetails } = useSelector(({ cartWishlist }) => cartWishlist);
  const { storeListData } = useSelector(({ store }) => store);
  const { shippingLabelLower } = useShippingLabel()

  const cartTotalAmount =
    productCartList &&
    productCartList.reduce((acc, prodcut) => {
      return acc + +prodcut?.final_total;
    }, 0);

  const finalCartAmount = +(cartType === "catering-meal"
                        ? productCartDetails?.catering_and_mealkit_item_amount
                        : productCartDetails?.final_cart_amount) ?? 0

  const bogoDiscount = +productCartDetails?.bogo_discount_amount ?? 0
  const bogoDiscountLabel = productCartDetails?.bogo_discount_amount_lable ?? ""

  const ebtProducts = productCartList.filter(product => product.ebt_item === "1")
  const nonEbtProducts = productCartList.filter(product => product.ebt_item === "0")
  const clientId = getLocalStorageValue("RSAclient-id");

  const ebtCartTotalAmount =
    ebtProducts &&
    ebtProducts.reduce((acc, prodcut) => {
      return acc + +prodcut?.final_total
    }, 0);

  const nonEbtCartTotalAmount =
    nonEbtProducts &&
    nonEbtProducts.reduce((acc, prodcut) => {
      return acc + +prodcut?.final_total
    }, 0);


  const selectedStore =
    storeListData &&
    storeListData.find(
      (store) =>
        store.ClientStoreId === getLocalStorageValue("selected-store-id")
    );

  const {
    allow_delivery = "0",
    allow_pickup = "0",
    minimum_delivery_order_amount = "0",
    minimum_pickup_order_amount = "0"
  } = productCartDetails

  let buttonEnable = false
  let minimum_order_amount_message = ""

  // enable disable button flag based on remaining amount and pickup or delivery
  if (allow_delivery === "1" && cartTotalAmount >= minimum_delivery_order_amount) {
    buttonEnable = true
  } else if (allow_pickup === "1" && cartTotalAmount >= minimum_pickup_order_amount) {
    buttonEnable = true
  }

  // min amount msg based on remaining amount and pickup or delivery
  if ((allow_delivery === "1" && minimum_delivery_order_amount > cartTotalAmount) && (allow_pickup === "1" && minimum_pickup_order_amount > cartTotalAmount)) {
    minimum_order_amount_message = `Min: <span className="delivery-text">$${minimum_pickup_order_amount} (pickup)</span><span className="danger">✘</span> &nbsp;&nbsp;&nbsp;&nbsp; <span className="delivery-text">$${minimum_delivery_order_amount} (${shippingLabelLower})</span> <span className="danger">✘</span>`
  }
  else if (allow_pickup === "1" && allow_delivery === "1" && minimum_delivery_order_amount > cartTotalAmount && minimum_pickup_order_amount <= cartTotalAmount) {
    minimum_order_amount_message = `Min:<span className="success">$${minimum_pickup_order_amount} (pickup)✔</span>&nbsp;&nbsp;&nbsp;&nbsp; <span className="delivery-text">$${minimum_delivery_order_amount} (${shippingLabelLower})</span> <span className="danger">✘</span>`
  } else if (allow_pickup === "1" && allow_delivery === "1" && minimum_pickup_order_amount > cartTotalAmount && minimum_delivery_order_amount <= cartTotalAmount) {
    minimum_order_amount_message = `Min:<span className="delivery-text">$${minimum_pickup_order_amount} (pickup)</span> <span className="danger">✘</span>&nbsp;&nbsp;&nbsp;&nbsp; <span className="success">$${minimum_delivery_order_amount} (${shippingLabelLower})✔</span>`
  }
  else if (allow_pickup === "1" && minimum_pickup_order_amount > cartTotalAmount) {
    minimum_order_amount_message = `Min: <span className="delivery-text">$${minimum_pickup_order_amount} (pickup)</span><span className="danger">✘</span>`
  } else if (allow_delivery === "1" && minimum_delivery_order_amount > cartTotalAmount) {
    minimum_order_amount_message = `Min:<span className="delivery-text">$${minimum_delivery_order_amount} (${shippingLabelLower})</span> <span className="danger">✘</span>`
  }

  const { allowGrocery, allowCatering } = useConfigHeader()
  const pathname = useLocation().pathname
  let showCheckoutNotAvailableMessage = false
  if ((pathname === "/your-cart" && allowGrocery) || (pathname === "/your-cart/catering-meal" && allowCatering)) {
    buttonEnable = true
  } else {
    showCheckoutNotAvailableMessage = true
  }

  return (
    <div className="proceed-checkout">
      <div className="box-title">
        <p>{clientId == 347 ? "School:" : "Store:"}{" "}{selectedStore && selectedStore.ClientStoreName}</p>
      </div>
      <div className="box-body">
        {(!!ebtProducts.length && !!nonEbtProducts.length) ? (
          <>
            <div className="all-text-alignment">
              <p>EBT Items(s) Total</p>
              <h2>{ebtCartTotalAmount ? `$${ebtCartTotalAmount.toFixed(2)}` : "$ 0"}</h2>
            </div>
            <div className="all-text-alignment">
              <p>Non EBT Items(s) Total</p>
              <h2>{nonEbtCartTotalAmount ? `$${nonEbtCartTotalAmount.toFixed(2)}` : "$ 0"}</h2>
            </div>
          </>
        ) : <div className="all-text-alignment">
          <p>Subtotal</p>
          <h2>{cartTotalAmount ? `$${cartTotalAmount.toFixed(2)}` : "$ 0"}</h2>
        </div>}
        {bogoDiscount > 0 && (
          <div className="all-text-alignment">
            <p>{bogoDiscountLabel}</p>
            <h2 className="bogo-discount">-${bogoDiscount.toFixed(2)}</h2>
          </div>
        )}
        <div className="all-text-alignment">
          <p>Total</p>
          <h2>{finalCartAmount ? `$${finalCartAmount.toFixed(2)}` : "$ 0"}</h2>
        </div>
        {!cartType && (
          <div className="proceed-to-checkout">
            <ReactHtmlParser
              htmlString={minimum_order_amount_message || ""}
            />
            <div className="ebt-message">* Any applicable coupons will be applied at the time of checkout.</div>
            {!!ebtProducts.length && <div className="ebt-message">Min order amount not applicable to orders with only EBT items</div>}
            {!!ebtProducts.length ? <Link to="/checkout">
              <button disabled={!buttonEnable}>
                <span>Proceed to Checkout</span>
                <i className="fa-solid fa-right-long"></i>
              </button>
            </Link> : buttonEnable ? (
              <Link to="/checkout">
                <button disabled={!buttonEnable}>
                  <span>Proceed to Checkout</span>
                  <i className="fa-solid fa-right-long"></i>
                </button>
              </Link>
            ) : (
              <button className="disabled" disabled={!buttonEnable}>
                <span>Proceed to Checkout</span>
                <i className="fa-solid fa-right-long"></i>
              </button>
            )}
          </div>
        )}
        {cartType === "catering-meal" && (
          <div className="proceed-to-checkout">
            <Link to="/checkout/catering-meal">
              <button disabled={!buttonEnable}>
                <span>Proceed to Checkout</span>
                <i className="fa-solid fa-right-long"></i>
              </button>
            </Link>

          </div>
        )}
        {showCheckoutNotAvailableMessage && (
          <div className="proceed-to-checkout checkout-locked">
            <div className="checkout-unavailable-message">
              <i className="fa-solid fa-store-slash" aria-hidden="true"></i>
              <span>Online checkout isn’t available for this store. Please choose a different store or contact us for assistance.</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default ProceedCheckout;
